export default "__VITE_ASSET__D2eu0ndR__"